import ReactDOM from 'react-dom/client';
import './index.css';
import { Canvas, useFrame, useThree } from '@react-three/fiber';
import * as THREE from "three";
import { useState, useEffect, useRef } from 'react';
import React from 'react';
import Footer from './components/Footer';
import Room from './components/Room';
import PLayer from './components/Player';
import VideoMesh from './components/VideoMesh';
import { ParticleText } from './components/TextParticles';
import Navigation from "./components/Navigation";
import Studio from "./components/Studio";
import MixedReality from "./components/MixedReality";
import Phygital from './components/Phygital';
import Artefact from './components/Artifact';
import Anamnesis from './components/Anamnesis';
import Blockchain from './components/Blockchain';
import Stele from './components/Stele';
import Mentions from './components/Mentions';

const root = ReactDOM.createRoot(document.getElementById('root'))

// Gestionnaire unique de la caméra
function CameraController({ target, lookAtTarget }) {
  const { camera } = useThree()

  useFrame(() => {
    // déplacement fluide de la position
    camera.position.lerp(target, 0.03)

    // déplacement fluide du lookAt
    const currentLookAt = new THREE.Vector3()
    camera.getWorldDirection(currentLookAt)
    currentLookAt.add(camera.position) // obtenir point visé actuel

    currentLookAt.lerp(lookAtTarget, 0.03)
    camera.lookAt(currentLookAt)
  })

  return null
}

function App() {
  const [targetPosition, setTargetPosition] = useState(new THREE.Vector3(0, 0, -5));
  const [lookAtTarget, setLookAtTarget] = useState(new THREE.Vector3(0, 0, -5));
  const [entered, setEntered] = useState(false);
  const [showNavigation, setShowNavigation] = useState(false);
  const [showVideoMesh, setShowVideoMesh] = useState(false);
  const [lang, setLang] = useState("fr");
  const [section, setSection]=useState("");
  const [isParticleTextVisible, setIsParticleTextVisible]=useState(true);
  const [isStudioVisible, setIsStudioVisible]=useState(false);
  const [isMixedRealityVisible, setIsMixedRealityVisible]=useState(false);
  const [isBlockChainVisible, setIsBlockChainVisible]=useState(false);
  const [isArtefactVisible, setIsArtefactVisible]=useState(false);
  const [isPhygitalVisible, setIsPhygitalVisible]=useState(false);
  const [isAnamnesisVisible, setIsAnamnesisVisible]=useState(false);
  const [isSteleVisible, setIsSteleVisible]=useState(false);
  const [isMentionVisible, setIsMentionVisible]=useState(false);
  const [videoActive, setVideoActive] = useState(false);




  // Timers pour montrer le VideoMesh et la Navigation après l'entrée
  useEffect(() => {
    if (!entered) return

    const timer1 = setTimeout(() => {
      setShowVideoMesh(true)
      setVideoActive(true)
    }, 2000)

    const timer2 = setTimeout(() => {
      setShowNavigation(true);
      setIsParticleTextVisible(false);
    }, 7000);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, [entered])

  useEffect(() => {
    if (window.innerWidth <= 1024) {
      // Caméra adaptée pour petit écran
      setTargetPosition(new THREE.Vector3(0, 1, -8));
      setLookAtTarget(new THREE.Vector3(0, 1, -5));
    }
  }, []);

  return (

    <>

      {showNavigation && <Navigation setTargetPosition={setTargetPosition} setShowVideoMesh={setShowVideoMesh}
                                      setLookAtTarget={setLookAtTarget} setSection={setSection}
                                      setIsStudioVisible={setIsStudioVisible}
                                      setIsMixedRealityVisible={setIsMixedRealityVisible}
                                      setIsBlockChainVisible={setIsBlockChainVisible}
                                      setIsArtefactVisible={setIsArtefactVisible}
                                      setIsAnamnesisVisible={setIsAnamnesisVisible}
                                      setIsPhygitalVisible={setIsPhygitalVisible}
                                      setIsSteleVisible={setIsSteleVisible}/>}

      <Canvas camera={{ position: [0, 0, -5] }}>

        <CameraController target={targetPosition}  lookAtTarget={lookAtTarget}/>
        
        <Room />

        {isParticleTextVisible && (
          <group position={[0, 0, -1]} rotation={[0, Math.PI, 0]}>
            <ParticleText setEntered={setEntered} setTargetPosition={setTargetPosition} setLookAtTarget={setLookAtTarget } />
          </group>
        )}

        {showVideoMesh && (  <VideoMesh url="/videos/flux_site.mp4" position={[0, 2, 9]} active={videoActive}  /> )}
 

        {isStudioVisible && <group position={[10,0,11]}><Studio  lang={lang}/></group>}
        {isArtefactVisible && <group position={[10,0,13]}><Artefact  lang={lang}/></group>}
        {isMixedRealityVisible && <group position={[10,0,15]}><MixedReality  lang={lang}/></group>}
        {isBlockChainVisible && <group position={[10,0,17]}><Blockchain lang={lang}/></group>}
        {isPhygitalVisible && <group position={[10,0,19]}><Phygital   lang={lang}/></group>}
        {isAnamnesisVisible && <group position={[10,0,21]}><Anamnesis  lang={lang}/></group>}
        {isSteleVisible && <group position={[0,0,0]}><Stele /></group>}

        <ambientLight intensity={0.1}/>


      
      </Canvas>

      <Footer setIsMentionVisible={setIsMentionVisible} />

      {isMentionVisible && <Mentions setIsMentionVisible={setIsMentionVisible} />}

    </>
    
  )
}

root.render(<App />)
